import { Breadcrumbs } from "components/breadcrumbs";
import { CreateSupportQAForm } from "./components";

export const CreateSupportQA: React.FC = () => {
    
  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Create Support Center Q&A" />
      <CreateSupportQAForm />
    </div>
  );
};
